<script>
  import KeyboardHandler from './KeyboardHandler';
  import ColorPickerDialog from './pages/Editor/ColorPickerDialog/ColorPickerDialog.svelte';
  import Editor from './pages/Editor/Editor.svelte';
  import ReloadDialog from './components/ReloadDialog/ReloadDialog.svelte';
  import ErrorDialog from './components/ErrorDialog/ErrorDialog.svelte';
  import ui from '/stores/UI';
  export let locale;

  console.log('locale', locale);
  ui.update((t) => {
    t.locale = locale;
  });
</script>

<KeyboardHandler />
{#if $ui.showErrorDialog}
  <ErrorDialog />
{/if}
{#if $ui.showReloadDialog}
  <ReloadDialog />
{/if}
<div class="application">
  <Editor />
</div>
<ColorPickerDialog />

<style>
  .application {
    flex-grow: 1;
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: auto 1fr;

    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    touch-action: none;
  }
</style>
